import {baseRequestService} from "../base.ts";
import {EventRequestCancelPost} from "../../types/domain.ts";

export const eventsEventIdRequestCancelPost = (eventId: string, data: EventRequestCancelPost) => baseRequestService({
    url: `/events/${eventId}/request_cancel`,
    method: 'POST',
    data
})